export enum StatusKYCStepOne {
  REJECTED_BY_WEBSITE = 'REJECTED_BY_WEBSITE',
  REJECTED_BY_INDUSTRY = 'REJECTED_BY_INDUSTRY',
  COMPLETED = 'COMPLETED',
  ENABLED = 'ENABLED'
}
